/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from "react";
import { Control, useController } from "react-hook-form";
import Radio from "../Radio";
import { SelectOptionType } from "../SelectField";

export interface RadioFieldProps {
  label?: string;
  name?: string;
  control?: Control<any>;
  radioValues: SelectOptionType[];
  className?: string;
  disabled?: boolean;
  alignment?: string;
  value?: string | string[];
  onChange?: (value: string | string[]) => void;
}

export const RadioField = memo(
  ({
    label,
    name = "",
    control,
    radioValues,
    className,
    disabled,
    alignment = "horizontal",
    value: propValue,
    onChange: propOnChange,
  }: RadioFieldProps) => {
    const controller =
      control && name ? useController({ name, control }) : null;

    const value = controller?.field.value ?? propValue ?? "";
    const onChange = controller?.field.onChange ?? propOnChange;
    const error = controller?.fieldState?.error;

    return (
      <Radio
        value={value ?? ""}
        variant="box"
        formLabel={label ?? undefined}
        name={name}
        radioValues={radioValues}
        onInputChange={(e) => {
          onChange?.(e);
        }}
        hasError={!!error}
        errorMessage={error?.message}
        className={className}
        disabled={disabled}
        alignment={alignment}
      />
    );
  }
);

export default RadioField;
